<script lang="ts">
    export function scrollTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })
    }
</script>

<div class="to-top smooth-shadow" on:click="{() => scrollTop()}" on:keypress>
    <figure>
        <img src="/assets/icons/lucide_chevron-up.svg" alt="zum Seitenanfang" />
    </figure>
</div>
